import { css } from '@emotion/css'
import { spacing, fontWeight, fontSize, breakpoint, mediaQueryHelper, colors } from '@offerzen/pinata'

const styles = {
  alternateHeading: css({
    textAlign: 'center',
  }),

  heading: css({
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.medium,
    color: colors.blackPearl,
    display: 'block',
    width: '100%',
    marginBottom: spacing.medium,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontWeight: fontWeight.medium,
      fontSize: fontSize.default,
    },
  }),

  buttonsContainer: css({
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      flex: '1 1 auto',
      ':not(:last-child)': {
        marginBottom: spacing.medium,
      },
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',

      '& > *': {
        ':not(:last-child)': {
          marginBottom: 0,
        },
        ':not(:first-child)': {
          marginLeft: spacing.medium,
        },
      },
    },
  }),

  seperator: css({
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: spacing.large,
    marginBottom: spacing.large,
    '&::before': {
      content: '""',
      height: '1px',
      borderBottom: `1px dashed ${colors.grayChateau}`,
      position: 'absolute',
      width: '100%',
      zIndex: 1,
    },
  }),

  seperatorText: css({
    color: colors.jumbo,
    fontWeight: fontWeight.semiBold,
    background: 'white',
    display: 'block',
    zIndex: 2,
    paddingRight: spacing.default,
    paddingLeft: spacing.default,
  }),

  disclaimer: css({
    marginTop: spacing.large,
    fontSize: fontSize.small,
    marginBottom: 0,
    '& a': {
      color: colors.cornflowerBlue,
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      marginTop: spacing.medium,
    },
  }),

  errorNotification: css({
    marginBottom: spacing.large,

    '& a': {
      color: colors.mandy,
      fontWeight: fontWeight.semiBold,
      textDecoration: 'underline',
    },
  }),
}

export default styles
